import React from 'react';
import styles from './StarField.module.css';

export default function StarField() {
  return (
    <section className={styles.space}>
      <div className={styles.stars}>
        <div className={styles.starsBack}></div>
        <div className={styles.starsMiddle}></div>
        <div className={styles.starsFront}></div>
      </div>
      <div className={styles.rocket}>
        <div className={styles.fuselage}>
          <div className={styles.nose}></div>
          <div className={styles.head}>
            <span className={styles.window}></span>
          </div>
          <div className={styles.neck}></div>
          <div className={styles.body}></div>
          <div className={styles.reactor}></div>
          <div className={styles.fire}>
            <div className={styles.spark1}></div>
            <div className={styles.spark2}></div>
            <div className={styles.spark3}></div>
            <div className={styles.spark4}></div>
            <div className={styles.spark5}></div>
            <div className={styles.spark6}></div>
          </div>
        </div>
        <div className={styles.leftFin}></div>
        <div className={styles.leftFinEnd}></div>
        <div className={styles.rightFin}></div>
        <div className={styles.rightFinEnd}></div>
      </div>
    </section>
  );
}
